"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemLogDatePicker = void 0;
var date_1 = require("@utils/date/date");
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var DateRangePicker_1 = require("@/react-app/common/components/DatePicker/DateRangePicker");
exports.ItemLogDatePicker = react_1.default.memo(function (props) {
    var defaultStartDate = props.defaultStartDate, setSearchParams = props.setSearchParams, searchParams = props.searchParams, fromParam = props.fromParam, toParam = props.toParam, minDate = props.minDate;
    var fromValue = fromParam ? new Date(fromParam) : undefined;
    var toValue = toParam ? (0, date_fns_1.set)(new Date(toParam), { milliseconds: 999 }) : undefined;
    var defaultToValue = (0, date_fns_1.set)(new Date(), __assign({ hours: 23, minutes: 59 }, date_1.FIFTY_NINE_SECONDS));
    var handleFromChange = function (date) {
        setSearchParams(__assign(__assign({}, searchParams), { from: date || undefined, currentPage: 0 }));
    };
    var handleToChange = function (date) {
        setSearchParams(__assign(__assign({}, searchParams), { to: date || undefined, currentPage: 0 }));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DateRangePicker_1.DateRangePicker, { fromDate: fromValue || defaultStartDate, toDate: toValue || null, setFromDate: handleFromChange, setToDate: handleToChange, defaultMinValue: minDate, defaultMaxValue: defaultToValue, dateFormat: "dd MMM yyyy hh:mm a", allowToNull: true })));
});
